import styled from 'styled-components';
import styles from '@utils/styles';

const HorizontalLine = styled.hr`
  margin: 20px 0;
  border-top: 2px dashed ${styles.colors.gray[400]};
  border-bottom: none;
`;

export default HorizontalLine;
